import React from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import { SettingsItem } from 'design-system/SettingsItem';
import { IconEmma } from 'design-system/icons';
import { IconShare } from 'design-system/icons/IconShare';
import { IconLink } from 'design-system/icons/IconLink';
import { rem } from 'design-system';
import { shareGroupCode, shareGroupLink } from '../utils/share';
import { groupModalContainerStyle } from './groupModalContainerStyle';
/**
 * Browsers can't read the device's contacts, so web has no "Add from
 * contacts" option. Adding by @EmmaTag opens the same screen as in the app.
 */
export const ShareGroupModal = {
    show: ({ onInviteContacts, group }) => {
        Modal.show(<>
        <SettingsItem light icon={<IconLink gradientKey="skyBlue"/>} title="Share via link" description="They can open the link to join the group" onPress={() => {
                Modal.hide(() => shareGroupLink(group));
            }}/>
        <SettingsItem light icon={<IconShare gradientKey="orange"/>} title="Share the group code" description="They can enter the code in Emma to join the group" onPress={() => {
                Modal.hide(() => shareGroupCode(group));
            }}/>
        <SettingsItem light icon={<IconEmma colorKey="brand"/>} title="Add by @EmmaTag" description="If you know their user handle, you can add them to the group" onPress={() => Modal.hide(onInviteContacts)}/>
      </>, {
            containerStyle: groupModalContainerStyle,
            title: 'Add members',
            textStyle: styles.textStyle,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    textStyle: {
        marginBottom: rem(8),
    },
});
